interface DeliveryDateOptions {
  expressDeliveryDate?: string;
  standardDeliveryDate?: string;
  isExpress?: boolean;
  isLoggedIn: boolean;
}

export function selectDeliveryDate({
  expressDeliveryDate,
  standardDeliveryDate,
  isExpress,
  isLoggedIn,
}: DeliveryDateOptions): string | undefined {
  if (isExpress && isLoggedIn) {
    return expressDeliveryDate;
  }

  return standardDeliveryDate;
}
